import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.875 11.119c.1-.195.1-.49 0-.783-.1-.098-.1-.194-.2-.293l-3-2.932a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.369l1.3 1.27h-6.6V3.3l1.3 1.27c.2.196.4.293.7.293s.5-.098.7-.294a.93.93 0 0 0 0-1.368l-3-2.932c-.1-.098-.2-.195-.3-.195-.2-.098-.5-.098-.8 0-.1.097-.2.097-.3.195l-3 2.932a.93.93 0 0 0 0 1.368c.4.391 1 .391 1.4 0l1.3-1.27v6.453h-6.6l1.3-1.272a.93.93 0 0 0 0-1.368.98.98 0 0 0-1.4 0l-3 2.932c-.1.098-.2.195-.2.293-.1.197-.1.49 0 .783.1.098.1.196.2.293l3 2.932c.2.196.4.294.7.294s.5-.098.7-.293a.93.93 0 0 0 0-1.369l-1.3-1.27h6.6v6.451l-1.3-1.27a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.367l3 2.934c.1.098.2.195.3.195.1.099.3.099.4.099s.3 0 .4-.099c.1-.098.2-.098.3-.195l3-2.933a.93.93 0 0 0 0-1.369.98.98 0 0 0-1.4 0l-1.3 1.27v-6.45h6.6l-1.3 1.27a.93.93 0 0 0 0 1.37c.2.194.5.293.7.293s.5-.099.7-.295l3-2.931c.1-.098.2-.197.2-.294z"
    }, null, -1)
  ]))]))
}
export default { render: render }